import { NavigationGuardNext, Route } from 'vue-router'
import store from '@/store'

function b2bAddonGuard(to: Route, from: Route, next: NavigationGuardNext): void {
  if (store.getters['subscription/isB2bPurchased']) {
    return next()
  }
  return next({ name: 'error-404' })
}

export default b2bAddonGuard
